import { MenuServiceTime } from 'scbk-services/types/menu/menu';
import { create } from 'zustand';
import { MenuServiceTimeLoader } from '../managers/MenuServiceTimeLoader';

/**
 * 메뉴 서비스 이용시간 Store state
 */
interface MenuServiceTimeStoreState {
    /**
     * 초기화 여부
     */
    initialized: boolean;

    /**
     * 서비스 이용시간 정보 목록
     */
    serviceTimes: Record<string, MenuServiceTime>;

    /**
     * 서비시 이용시간 정보 로드
     * @param raw
     * @returns
     */
    load: (raw: string) => void;

    /**
     * 메뉴ID로 서비스 이용시간 정보를 조회한다.
     * @param id 메뉴ID
     * @returns 서비스 이용시간 정보 조회결과
     */
    find: (id: string) => MenuServiceTime | undefined;

    /**
     * 서비스 이용시간 정보 초기화
     * @returns
     */
    clear: () => void;
}

/**
 * 메뉴 서비스 이용시간 Store
 */
const useMenuServiceTimeStore = create<MenuServiceTimeStoreState>((set, get) => ({
    initialized: false,
    serviceTimes: {},

    /**
     * 메뉴 서비시 이용시간 로드
     * @param raw 원본 xml 문자열
     */
    load: async (raw: string) => {
        const serviceTimeLoader = new MenuServiceTimeLoader();
        const serviceTimes = await serviceTimeLoader.load(raw);

        console.log('# 메뉴 이용시간정보 로드 결과: ', serviceTimes);

        set({
            initialized: true,
            serviceTimes,
        });
    },

    /**
     * 메뉴ID로 서비스이용시간 정보를 조회한다.
     * @param id
     * @returns
     */
    find: (id: string): MenuServiceTime | undefined => {
        if (!id) {
            return;
        }
        return get().serviceTimes[id];
    },

    /**
     * 메뉴 서비스 이용시간 정보 초기화
     */
    clear: () => {
        set({
            initialized: false,
            serviceTimes: {},
        });
    },
}));

export { useMenuServiceTimeStore };
